var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { InputCheckbox } from '@creditornot/cb-checkbox';
import MenuAccordionItem from './MenuAccordionItem';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1;\n  padding-inline-start: 8px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"], ["\n  flex: 1;\n  padding-inline-start: 8px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])));
var CollapsedContent = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-inline-start: 24px;\n\n  [data-cb-menu-item] {\n    margin-left: -8px;\n    margin-right: -8px;\n  }\n\n  > * + * {\n    margin-top: 8px;\n  }\n"], ["\n  padding-inline-start: 24px;\n\n  [data-cb-menu-item] {\n    margin-left: -8px;\n    margin-right: -8px;\n  }\n\n  > * + * {\n    margin-top: 8px;\n  }\n"])));
var MenuAccordionCheckboxItem = function (_a) {
    var accordionContent = _a.accordionContent, _b = _a.checkboxProps, checkboxProps = _b === void 0 ? {} : _b, children = _a.children, disabled = _a.disabled, rest = __rest(_a, ["accordionContent", "checkboxProps", "children", "disabled"]);
    return (React.createElement(MenuAccordionItem, __assign({ accordionContent: React.createElement(CollapsedContent, null, accordionContent), disabled: disabled }, rest),
        React.createElement(Container, null,
            React.createElement(InputCheckbox, __assign({}, checkboxProps, { disabled: checkboxProps.disabled === undefined ? disabled : checkboxProps.disabled, onClick: function (event) {
                    event.stopPropagation();
                    if (checkboxProps.onClick) {
                        checkboxProps.onClick(event);
                    }
                } })),
            React.createElement(Content, null, children))));
};
export default MenuAccordionCheckboxItem;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=MenuAccordionCheckboxItem.js.map